import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums';

interface UpsertCostForDesiPayload {
    shippingCompanyId: number;
    desi: number;
    cost: number;
    validFrom: string | Date | null;
    validTo: string | Date | null;
    changedBy: string;
}

interface DeleteSellerShipmentCostsPayload {
    shippingCompanyId: number;
    desi: number;
    startDate: string | Date | null;
    expirationDate: string | Date | null;
}

const UpsertShippingCompanyCostForDesi = (data: UpsertCostForDesiPayload) =>
    request({
        url: ApiURL.Command.UpsertShippingCompanyCostForDesi,
        method: RequestType.POST,
        data,
    });

const UpsertBulkShippingCompanyCostForDesi = (formData: FormData) =>
    request({
        url: ApiURL.Command.UpsertBulkShippingCompanyCostForDesi,
        method: RequestType.POST,
        data: formData,
        requestType: 'FromForm',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        },
    });

const UpsertSellerShipmentCosts = (data: any) =>
    request({
        url: ApiURL.Command.UpsertSellerShipmentCosts,
        method: RequestType.POST,
        data,
    });

const InsertBulkSellerShipmentCostsExcel = (formData: FormData) =>
    request({
        url: ApiURL.Command.InsertBulkSellerShipmentCostsExcel,
        method: RequestType.POST,
        data: formData,
        requestType: 'FromForm',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        },
    });

const DeleteSellerShipmentCosts = (data: DeleteSellerShipmentCostsPayload) =>
    request({
        url: ApiURL.Command.DeleteSellerShipmentCosts,
        method: RequestType.DELETE,
        data,
    });

const ShippingCommand = {
    UpsertShippingCompanyCostForDesi,
    UpsertBulkShippingCompanyCostForDesi,
    UpsertSellerShipmentCosts,
    InsertBulkSellerShipmentCostsExcel,
    DeleteSellerShipmentCosts,
};

export default ShippingCommand;
